import { QueryClient } from '@tanstack/react-query';


const showRateLimitNotification = (message?: string) => {
  const defaultMessage = '요청이 너무 많습니다. 잠시 후 다시 시도해주세요.';
  const displayMessage = message || defaultMessage;
  
  
  const existingNotification = document.getElementById('rate-limit-notification');
  if (existingNotification) {
    existingNotification.remove();
  }
  
  
  const notification = document.createElement('div');
  notification.id = 'rate-limit-notification';
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #ff6b6b, #ee5a52);
    color: white;
    padding: 16px 20px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.3);
    z-index: 10000;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    max-width: 350px;
    animation: slideIn 0.3s ease-out;
    border-left: 4px solid #ff4757;
  `;
  
  notification.innerHTML = `
    <div style="display: flex; align-items: center; gap: 12px;">
      <div style="font-size: 20px;">⚠️</div>
      <div>
        <div style="font-weight: 600; margin-bottom: 4px;">요청 한도 초과</div>
        <div style="opacity: 0.9; font-size: 13px;">${displayMessage}</div>
      </div>
      <button onclick="this.parentElement.parentElement.remove()" 
              style="background: none; border: none; color: white; font-size: 20px; cursor: pointer; padding: 0; margin-left: 8px;">×</button>
    </div>
  `;
  
  
  if (!document.getElementById('rate-limit-styles')) {
    const style = document.createElement('style');
    style.id = 'rate-limit-styles';
    style.textContent = `
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  document.body.appendChild(notification);
  
  
  setTimeout(() => {
    if (notification.parentElement) {
      notification.style.animation = 'slideOut 0.3s ease-in';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }
  }, 5000);
};


export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      
      staleTime: 12 * 60 * 60 * 1000,  
      gcTime: 24 * 60 * 60 * 1000,     
      
      
      refetchOnWindowFocus: false,      
      refetchOnReconnect: true,         
      refetchOnMount: true,             
      
      
      refetchInterval: false,           
      
      
      retry: (failureCount, error: any) => {
        
        if (error?.response?.status === 429) {
          console.warn('🚨 Rate limit hit - not retrying');
          
          showRateLimitNotification(error?.response?.data?.message);
          return false;
        }
        
        if (error?.response?.status >= 500) {
          return failureCount < 2;
        }
        
        if (error?.response?.status >= 400) {
          return false;
        }
        
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), 
    },
    mutations: {
      
      retry: 1,
      retryDelay: 1000,
    },
  },
});


export const invalidateDashboardCache = (storeId?: string) => {
  if (storeId) {
    
    queryClient.invalidateQueries({ 
      queryKey: ['dashboard', storeId] 
    });
  } else {
    
    queryClient.invalidateQueries({ 
      queryKey: ['dashboard'] 
    });
  }
};

export const clearAllCache = () => {
  queryClient.clear();
};


export const getCacheStats = () => {
  const queries = queryClient.getQueryCache().getAll();
  const mutations = queryClient.getMutationCache().getAll();
  
  
  return {
    queries: queries.length,
    mutations: mutations.length,
    active: queries.filter(q => q.getObserversCount() > 0).length,
    stale: queries.filter(q => q.isStale()).length,
  };
};